module.exports = __webpack_public_path__ + "img/messagenull.a437422e.jpg";